import EmberRouter from '@embroider/router';
import config from 'marcemira/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('about');

  // 404 error route
  this.route('error', { path: '/*path' });
});
